import { GregorioGlyphType } from '../../gregorio-chant/enums/GregorioGlyphType';

export const PunctaInclinata = [
  GregorioGlyphType.PUNCTA_INCLINATA,
  GregorioGlyphType._2_PUNCTA_INCLINATA_ASCENDENS,
  GregorioGlyphType._2_PUNCTA_INCLINATA_DESCENDENS,
  GregorioGlyphType._3_PUNCTA_INCLINATA_ASCENDENS,
  GregorioGlyphType._3_PUNCTA_INCLINATA_DESCENDENS,
  GregorioGlyphType._4_PUNCTA_INCLINATA_ASCENDENS,
  GregorioGlyphType._4_PUNCTA_INCLINATA_DESCENDENS,
  GregorioGlyphType._5_PUNCTA_INCLINATA_ASCENDENS,
  GregorioGlyphType._5_PUNCTA_INCLINATA_DESCENDENS,
];
